var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:{
    'ph-checkbox': true,
    'is-checked': _vm.checked
  }},[_c('span',{staticClass:"ph-checkbox__input"},[_c('span',{class:{
        'ph-checkbox__inner': true,
        'is-checked': _vm.checked
      }}),_c('input',{staticClass:"ph-checkbox__original",attrs:{"type":"checkbox"},on:{"change":_vm.onChange}})]),_c('span',{staticClass:"ph-checkbox__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }